export default __webpack_public_path__ + "static/media/cmu-wordmark-stacked.026adde7.png";